{
  "notFoundTitle": "找不到頁面",
  "notFoundBody": "此拍賣品不存在或已被撤回。",
  "backToAuctions": "返回拍賣列表",
  "genericTitle": "發生錯誤",
  "genericBody": "請重試或返回主頁。",
  "goHome": "返回主頁",
  "offline": "您似乎已離線。",
  "emptyTitle": "暫時未有內容。",
  "loadFailed": "目前無法載入。",
  "tryAgain": "重試",
  "routeErrorTitle": "發生錯誤",
  "routeErrorBody": "目前無法載入此頁面，請重試——如問題持續，您可以返回上一頁或回到主頁。",
  "retry": "重試",
  "back": "返回",
  "notFound404": "404",
  "notFoundHeading": "找不到頁面",
  "notFoundDetail": "您要找的頁面不存在，或已被移動。",
  "home": "主頁",
  "searchAuctions": "搜尋拍賣",
  "retrying": "重試中…"
}
